import React from 'react';
import PropTypes from 'prop-types';

const PublicFlagRenderer = ({ value }) => value
  ? <span>Public</span>
  : <span>Private</span>;

PublicFlagRenderer.propTypes = {
  value: PropTypes.bool.isRequired,
};

export default PublicFlagRenderer;
